import React, { Suspense, useState, useEffect } from "react";
import "bootstrap/dist/css/bootstrap.min.css";
import "../Subscription/Subscription.css";

import { Button } from "reactstrap";

import Loading from "../../components/Loading";
import Footer from "../../DefaultLayout/Footer";

import DashboardNavbar from "../../DefaultLayout/DashboardNavbar.js";
import LoggedHeader from "../../DefaultLayout/LoggedHeader";
import { connect, useSelector } from "react-redux";
import {
  getAllSubscription,
  buySubscription,
} from "../../actions/subscription.js";
import { toast } from "react-toastify";
import { useHistory } from "react-router";
import swal from "sweetalert";
import { runningSubscription } from "../../actions/subscription";
import PaymentModal from "./PaymentModal";

const Subscription = (props) => {
  const {  label } = props;
  const { frontLabelsName } = label;
  const userName = localStorage.getItem("user");


  const [ setRunningSub] = useState("");
  const [showPaymentModal, setShowPaymentModal] = useState(false);


  const subscriptions = useSelector((state) => state.subscription);
  const { allSubscription, loading, runningSubscription } = subscriptions;
  const subscription_details = runningSubscription?.message;

  useEffect(() => {
    props.getAllSubscription();
   
  }, []);

  // useEffect(() => {
  //   const userName1 = localStorage.getItem("user");
  //   props.runningSubscription(userName1);

  // }, []);

  const handleSubscribe = (datas) => {
    const data = {
      plan_id: datas,
      user_id: userName,
    };
  
    swal({
      title: frontLabelsName
        ? frontLabelsName.filter((e) => e.key == "lbl_get_access_to_leigulistinn!").length > 0
          ? frontLabelsName.filter((e) => e.key == "lbl_get_access_to_leigulistinn!")[0][
              "value"
            ] || "lbl_get_access_to_leigulistinn!"
          : "lbl_get_access_to_leigulistinn!"
        : "lbl_get_access_to_leigulistinn!",
      text: `${
        frontLabelsName
          ? frontLabelsName.filter((e) => e.key == "lbl_subscription_amount_is")
              .length > 0
            ? frontLabelsName.filter(
                (e) => e.key == "lbl_subscription_amount_is"
              )[0]["value"] || "lbl_subscription_amount_is"
            : "lbl_subscription_amount_is"
          : "lbl_subscription_amount_is"
      } ISK${allSubscription?.amount}`,
      icon: "info",
      buttons: [
        frontLabelsName
          ? frontLabelsName.filter((e) => e.key == "lbl_cancel").length > 0
            ? frontLabelsName.filter((e) => e.key == "lbl_cancel")[0]["value"] ||
              "lbl_cancel"
            : "lbl_cancel"
          : "lbl_cancel",
        frontLabelsName
          ? frontLabelsName.filter((e) => e.key == "lbl_ok").length > 0
            ? frontLabelsName.filter((e) => e.key == "lbl_ok")[0]["value"] ||
              "lbl_ok"
            : "lbl_ok"
          : "lbl_ok",
      ],
      dangerMode: true,
      className: "bg-button",
    }).then((willDelete) => {
      if (willDelete) {
        setShowPaymentModal(true);
   
      }
    });
  };



  const savePaymentModal = () => {
    setShowPaymentModal(false);
  };
  return (
    <React.Fragment>
      <Suspense fallback={<Loading />}>
        <LoggedHeader />
        {/* <NavbarSection /> */}
        <DashboardNavbar/>
      </Suspense>
      <div className="container custom-add">
        <div className="main-div-manage mb-5 pt-5">
          <div className="main-text-sub-title">
            <h1 className="text-center">
              {frontLabelsName
                ? frontLabelsName.filter(
                    (e) => e.key == "lbl_subscription_information1"
                  ).length > 0
                  ? frontLabelsName.filter(
                      (e) => e.key == "lbl_subscription_information1"
                    )[0]["value"] || "lbl_subscription_information1"
                  : "lbl_subscription_information1"
                : "lbl_subscription_information1"}{" "}
              <br />
              {frontLabelsName
                ? frontLabelsName.filter(
                    (e) => e.key == "lbl_subscription_information2"
                  ).length > 0
                  ? frontLabelsName.filter(
                      (e) => e.key == "lbl_subscription_information2"
                    )[0]["value"] || "lbl_subscription_information2"
                  : "lbl_subscription_information2"
                : "lbl_subscription_information2"}
            </h1>
            <p className="text-center">
              {frontLabelsName
                ? frontLabelsName.filter(
                    (e) => e.key == "lbl_subscription_information3"
                  ).length > 0
                  ? frontLabelsName.filter(
                      (e) => e.key == "lbl_subscription_information3"
                    )[0]["value"] || "lbl_subscription_information3"
                  : "lbl_subscription_information3"
                : "lbl_subscription_information3"}
              <br />

              {frontLabelsName
                ? frontLabelsName.filter(
                    (e) => e.key == "lbl_subscription_information4"
                  ).length > 0
                  ? frontLabelsName.filter(
                      (e) => e.key == "lbl_subscription_information4"
                    )[0]["value"] || "lbl_subscription_information4"
                  : "lbl_subscription_information4"
                : "lbl_subscription_information4"}
            </p>
          </div>
  

          {!loading && allSubscription && (
            <div className="main-subcribtion">
              <div className="sub-box">
                <div className="sub-box-yellow"></div>
                <div className="position-set">
                  <div className="center-desc-box">
                    <div className="top-title-box">
                      <h2 className="text-center">
                        {allSubscription?.name}
                      </h2>
                      <h1 className="text-center">
                        ISK{allSubscription?.amount}
                      </h1>
                      <p className="text-center">
                        {frontLabelsName
                          ? frontLabelsName.filter(
                              (e) => e.key == "lbl_subscription_price_msg1"
                            ).length > 0
                            ? frontLabelsName.filter(
                                (e) => e.key == "lbl_subscription_price_msg1"
                              )[0]["value"] || "lbl_subscription_price_msg1"
                            : "lbl_subscription_price_msg1"
                          : "lbl_subscription_price_msg1"}
                        <br />
                        dolor sit amet
                        {frontLabelsName
                          ? frontLabelsName.filter(
                              (e) => e.key == "lbl_subscription_price_msg2"
                            ).length > 0
                            ? frontLabelsName.filter(
                                (e) => e.key == "lbl_subscription_price_msg2"
                              )[0]["value"] || "lbl_subscription_price_msg2"
                            : "lbl_subscription_price_msg2"
                          : "lbl_subscription_price_msg2"}
                      </p>
                    </div>
                  </div>
                </div>

                <div className="white-bottom-box"></div>
                <div className="details-box">
                  <span className="set-fn-gap">
                    <img src="assets/Shape.svg" />

                    {frontLabelsName
                      ? frontLabelsName.filter(
                          (e) => e.key == "lbl_subscription_detail1"
                        ).length > 0
                        ? frontLabelsName.filter(
                            (e) => e.key == "lbl_subscription_detail1"
                          )[0]["value"] || "lbl_subscription_detail1"
                        : "lbl_subscription_detail1"
                      : "lbl_subscription_detail1"}
                  </span>
                  <span className="set-fn-gap">
                    <img src="assets/Shape.svg" />{" "}
                    {frontLabelsName
                      ? frontLabelsName.filter(
                          (e) => e.key == "lbl_subscription_detail2"
                        ).length > 0
                        ? frontLabelsName.filter(
                            (e) => e.key == "lbl_subscription_detail2"
                          )[0]["value"] || "lbl_subscription_detail2"
                        : "lbl_subscription_detail2"
                      : "lbl_subscription_detail2"}
                  </span>
                  <span className="set-fn-gap">
                    <img src="assets/Shape.svg" />{" "}
                    {frontLabelsName
                      ? frontLabelsName.filter(
                          (e) => e.key == "lbl_subscription_detail3"
                        ).length > 0
                        ? frontLabelsName.filter(
                            (e) => e.key == "lbl_subscription_detail3"
                          )[0]["value"] || "lbl_subscription_detail3"
                        : "lbl_subscription_detail3"
                      : "lbl_subscription_detail3"}
                  </span>
                  <span className="set-fn-gap">
                    <img src="assets/Shape.svg" />{" "}
                    {frontLabelsName
                      ? frontLabelsName.filter(
                          (e) => e.key == "lbl_subscription_detail4"
                        ).length > 0
                        ? frontLabelsName.filter(
                            (e) => e.key == "lbl_subscription_detail4"
                          )[0]["value"] || "lbl_subscription_detail4"
                        : "lbl_subscription_detail4"
                      : "lbl_subscription_detail4"}
                  </span>
                  <span className="set-fn-gap2">
                    <img src="assets/ccros.svg" />{" "}
                    {frontLabelsName
                      ? frontLabelsName.filter(
                          (e) => e.key == "lbl_subscription_detail5"
                        ).length > 0
                        ? frontLabelsName.filter(
                            (e) => e.key == "lbl_subscription_detail5"
                          )[0]["value"] || "lbl_subscription_detail5"
                        : "lbl_subscription_detail5"
                      : "lbl_subscription_detail5"}
                  </span>
                  <div className="button-set-sub">
                    {subscription_details !== "Your subscription is active." ? (
                      <Button
                        onClick={() => handleSubscribe(allSubscription._id)}
                      >
                        {frontLabelsName
                          ? frontLabelsName.filter((e) => e.key == "lbl_get_started")
                              .length > 0
                            ? frontLabelsName.filter(
                                (e) => e.key == "lbl_get_started"
                              )[0]["value"] || "lbl_get_started"
                            : "lbl_get_started"
                          : "lbl_get_started"}
                      </Button>
                    ) : (
                      <Button
                        onClick={() => handleSubscribe(allSubscription._id)}
                        disabled={
                          subscription_details ==
                            "Your subscription is active." && true
                        }
                      >
                        {frontLabelsName
                          ? frontLabelsName.filter(
                              (e) => e.key == "lbl_already_subscribed"
                            ).length > 0
                            ? frontLabelsName.filter(
                                (e) => e.key == "lbl_already_subscribed"
                              )[0]["value"] || "lbl_already_subscribed"
                            : "lbl_already_subscribed"
                          : "lbl_already_subscribed"}
                      </Button>
                    )}
                  </div>
                </div>
                <div className="payment_modal">
                  <PaymentModal
                    showModal={showPaymentModal}
                    closeModal={savePaymentModal}
                    amount={allSubscription?.amount}
                    id={allSubscription._id}
                    setRunningSub={setRunningSub}
                  />
                </div>
              </div>
            </div>
          )}
          {loading && <Loading />}
        </div>
      </div>
      <Suspense fallback={<Loading />}>
        <Footer />
      </Suspense>
    </React.Fragment>
  );
};

const mapStateToProps = (state) => ({
  auth: state.auth,
  label: state.language,
});

export default connect(mapStateToProps, {
  getAllSubscription,
  buySubscription,
  runningSubscription,
})(Subscription);
